{
  "title": "Branding Smite",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "The next time you hit a creature with a weapon attack before this spell ends, the weapon gleams with astral radiance as you strike. The attack deals an extra 2d6 radiant damage to the target, which becomes visible if it is invisible, and the target sheds dim light in a 5-foot radius and can’t become invisible until the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the extra damage increases by 1d6 for each slot level above 2nd."
  ],
  "spellLists": ["paladin"]
}
